import { FeatureFlag, ResolverTag } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import StarsDropDown from '@swf/components/Inputs/StarsDropDown';
import Text from '@swf/components/Inputs/Text';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  minLength,
  mustNotContainNumber,
  mustNotContainSymbols,
  required
} from '@swf/core/utils/validators';
import states from '@swf/generated/states.json';

import {
  TXTCLI_City,
  TXTCLI_City_must_be_at_least_2_charac_ELL,
  TXTCLI_Country,
  TXTCLI_Please_enter_ZIP___Postal_Code,
  TXTCLI_State___Province,
  TXTCLI_Zip_Post_Code,
  TXTWCL_Please_contact_Xa_hrefXXcontac_ELL_2,
  TXTWCL_The_city_you_have_entered_is_i_ELL_1
} from './AddressFields.messages.json';

interface Props {
  disabled?: boolean;
  showStates: boolean;
  restricted: boolean;
  children: React.ReactNode;
}

const AddressFields: React.FC<Props> = ({ disabled, showStates, restricted, children }) => {
  const country = useSelector(select.account.getCountry) as string;
  const countryStates = country && states[country];
  const userId = useSelector(select.account.getUserId);
  const email = useSelector(select.account.getEmail);
  const locale = useSelector(select.locale.get);
  const euDeOasisStreetAddress = useFeature(FeatureFlag.EuDeOasisStreetAddress);

  const cityField = (
    <Text
      id="city"
      label={TXTCLI_City}
      disabled={restricted || disabled}
      validators={[
        required(),
        minLength(2, TXTCLI_City_must_be_at_least_2_charac_ELL),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_city_you_have_entered_is_i_ELL_1
        ),
        mustNotContainNumber(TXTWCL_The_city_you_have_entered_is_i_ELL_1)
      ]}
    />
  );
  return (
    <>
      {restricted && (
        <Translation
          values={{
            a: (msg: string) => (
              <ResolverLink
                resolverTag={ResolverTag.AddressChangeSupport}
                query={{ language: locale, userId, email }}
              >
                {msg}
              </ResolverLink>
            )
          }}
          {...TXTWCL_Please_contact_Xa_hrefXXcontac_ELL_2}
        />
      )}
      {children}
      {!euDeOasisStreetAddress && cityField}
      <Text
        id="zip"
        label={TXTCLI_Zip_Post_Code}
        disabled={restricted || disabled}
        validators={[required(TXTCLI_Please_enter_ZIP___Postal_Code)]}
      />
      {euDeOasisStreetAddress && cityField}
      {showStates && countryStates && (
        <StarsDropDown
          id="state"
          label={TXTCLI_State___Province}
          options={countryStates}
          disabled={restricted || disabled}
          validators={[required()]}
        />
      )}
      {showStates && <Text id="country" label={TXTCLI_Country} disabled />}
    </>
  );
};

export default AddressFields;
